export default "__VITE_ASSET__DUbcGABH__"